import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../shared/api.service';
import { VerticalsService } from '../shared/verticals.service';

@Component({
    selector: 'app-verticals',
    templateUrl: './verticals.component.html',
    styleUrls: ['./verticals.component.css'],
})
export class VerticalsComponent implements OnInit, OnDestroy {
    displayedColumns: string[] = [];
    canEdit = false;
    verticalsEditor = '';
    error = '';
    heartbeatSubscription;
    loading = false;
    saved = false;
    inputSubscription;
    loaded = false;

    constructor(private api: ApiService, public verticalsService: VerticalsService) {}

    ngOnInit(): void {
        const user = this.api.getProp('user');
        if (user.role == 'administrator' || user.role == 'editor') {
            this.canEdit = true;
        }
        if (this.canEdit) {
            this.checkLock(false);
            this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
                this.checkLock(false);
            });
        }
        
        this.displayedColumns = this.verticalsService.getTaxonomyVerticals().map((tax) => tax.name);
        this.displayedColumns = ['Site', ...this.displayedColumns];
    }

    updateVertical(event, blogId, termId) {
        this.resetError();

        const verticals = this.verticalsService.getVerticals();

        let verticalIndex = verticals.findIndex(
            (vertical) => vertical.site[0].blog_id === blogId
        );
        if (verticalIndex === -1) return;

        let stateIndex = verticals[verticalIndex].states.findIndex(
            (state) => state.term_id === termId
        );
        if (stateIndex === -1) return;

        verticals[verticalIndex].states[stateIndex].allowed =
            event.checked;

        this.loading = true;
        
        this.verticalsService.updateVerticals(verticals)
            .add(() => {
                this.loading = false;
                this.error = this.verticalsService.getError();
            }
        );
    }

    checkLock(takeover) {
        this.api
            .doAction('post', 'verticals', {
                action: 'check_lock',
            })
            .subscribe(
                (data) => {
                    if (data.locked && !takeover) {
                        this.verticalsEditor = data.verticalsEditor;
                    }
                    if (takeover || !data.locked) {
                        this.setLock('update');
                    }
                },
                (err) => {
                    this.error = err.error.message;
                    throw err;
                }
            );
    }

    setLock(action) {
        this.resetError();
        this.loading = true;
        this.api
            .doAction('post', 'verticals', {
                action: 'set_lock',
                lockAction: action,
            })
            .subscribe(
                (data) => {
                    if (action == 'update') {
                        this.verticalsEditor = '';
                    }
                },
                (err) => {
                    this.error = err.error.message;
                    throw err;
                }
            )
            .add(() => {
                this.loading = false;
            });
    }

    resetError() {
        this.verticalsService.resetError();
        this.error = '';
        this.saved = false;
    }
    ngOnDestroy() {
        this.setLock('delete');
        if (this.heartbeatSubscription) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}
